export interface CustomEnvironmentParams {
  gtm_auth: string;
  gtm_preview: string;
}

export interface SnippetParams {
  id: string;
  environment?: CustomEnvironmentParams;
}

export interface GtmVirtualPageView {
  event: GTMEvent.VirtualPageView;
  user_status: 'Logged-in' | 'Logged-out';
  user_id?: string;
  page_location: string;
  page_title: string;
  page_referrer: string;
}

export interface GtmPurchaseEventItem {
  item_id: string;
  item_name: string;
  price: number;
}

export interface GtmPurchaseEvent {
  event: GTMEvent;
  ecommerce: {
    transaction_id?: string;
    value: number;
    tax?: number;
    currency: 'PLN';
    landing_source?: string;
    coupon?: string;
    payment_type?: string;
    user_data?: {
      email: string;
      customer_type: 'new' | 'returning';
    };
    items: GtmPurchaseEventItem[];
  };
}

export enum GTMEvent {
  Registration = 'registration',
  AddCardInfo = 'add_card_info',
  Purchase = 'purchase',
  VirtualPageView = 'virtual_page_view',
}
